import { postTypeToChannelType, extract } from '@/assets/modules/channels/paramExtractor'
import moment from 'moment'

const calendarIcons = (item, getters) => {
  let img = ((getters.icons || {}).campaign || {}).quickPost
  if (item.__typename === 'Campaign') img = ((getters.icons || {}).campaign || {})[item.type]

  const parts = { prepend: `<img src="${img}" width="15px" height="15px" />` }

  // Fill event channel icons
  const used = {}
  let append = ''
  const appendFnc = (icon) => `<img src="${((getters.qlogos || {}).light || {})[icon]}" width="15px" height="15px" class="pt-1 pb-1 mr-1" />`
  if (item.__typename === 'Campaign' || item.__typename === 'Advertisable') {
    for (const { type } of (item.events || {}).set || []) {
      const cType = postTypeToChannelType(type)

      if (!used[cType]) {
        const { lightIcon } = extract(cType)
        append += appendFnc(lightIcon)
      }
      used[cType] = true
    }
  } else {
    const type = postTypeToChannelType(item.type)
    const { lightIcon } = extract(type)
    append = appendFnc(lightIcon)
  }

  parts.append = append
  return parts
}

const calendarIconsChannel = (item, getters) => {
  const { type } = item
  const { icon, pack } = extract(postTypeToChannelType(type))
  let img = ((getters.qlogos || {})[pack] || {})[icon]

  return { prepend: `<img src="${img}" width="15px" height="15px" class="pt-1 pb-1 mr-1" />` }
}

export default {
  calendarMeta (item, getters = {}, onlyChannel = false) {
    const { advertisable = {}, campaign = {}, channel = {} } = item
    let start = item.startsAt || item.publishAt
    let end = (item.expiresAt || item.removeAt) ? item.expiresAt || item.removeAt : null

    // Determine advertisable duration based on it's events
    if (item.__typename === 'Advertisable') {
      const { events: { set = [] } } = item
      start = set[0].publishAt
      end = set[0].removeAt

      for (const { publishAt, removeAt } of set) {
        if (!start || moment(publishAt).isBefore(moment(start))) {
          start = publishAt
        }
        if (!end || moment(removeAt).isAfter(moment(end))) {
          end = removeAt
        }
      }
    }

    // Create the event
    return {
      className: `${postTypeToChannelType(item.type) || item.type}-post`,
      title: item.label || (advertisable || {}).label || (channel || {}).label,
      start,
      end,
      eventLabelParts: onlyChannel ? calendarIconsChannel(item, getters) : calendarIcons(item, getters),
      data: {
        status: item.status,

        // Duplicate start end, because fullcalendar edites these in real time
        start,
        end,
        icon: item.type,
        type: item.type,
        fromType: item.__typename,
        uuid: item.id
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/standard/display/calendarHelpers.js